import App from './App.jsx'
import './index.css'
import 'react18-json-view/src/style.css'
import ReactDOM from 'react-dom/client'
import { Providers } from './components/providers/Providers.jsx'

// Ensure we're in a browser environment
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const rootElement = document.getElementById('root')
    if (rootElement) {
        ReactDOM.createRoot(rootElement).render(
            <Providers>
                <App />
            </Providers>
        )
    }
}
